import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { useIsSkipifyAdmin } from '../../hooks';
import { configurationPaths } from '../../util/constants';
import { AuditLogsTable } from './components/AuditLogsTable';

export const AuditLogs = () => {
  const { isLoading: merchantInfoLoading } = useMerchant();
  const isSkipifyAdmin = useIsSkipifyAdmin();

  if (!isSkipifyAdmin) {
    return <Navigate to={configurationPaths.SETTINGS} replace />;
  }

  return (
    <PageWrapper
      data-testid="AUDIT_LOGS"
      title="Audit Logs"
      description="Review audit activity for this merchant."
      isLoading={merchantInfoLoading}
    >
      <Box>
        <AuditLogsTable />
      </Box>
    </PageWrapper>
  );
};
